import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { FDStat } from '@facet-wealth/design';

export const metaOverrideSet = fr.metaOverride({ BaseOverrideNoHidden })
  .overrideAll({
    readonly: true,
    _component: () => FDStat,
  }, { ordinal: 200 });
